import React from 'react';
import { Button, Grid, TextField } from '@mui/material';
import { Formik } from 'formik';
import PasswordField from '../PasswordField';
import validationSignUp from './validation';

interface SignUpProps {
  handleSubmitChange: (
    params: SignUpTypes,
    setSubmitting: (isSubmitting: boolean) => void,
  ) => void;
}

interface SignUpTypes {
  name: string;
  email: string;
  password: string;
  repeatPassword: string;
}

const SignUpForm: React.FC<SignUpProps> = ({ handleSubmitChange }) => {
  return (
    <>
      <Formik
        initialValues={{
          email: '',
          name: '',
          password: '',
          repeatPassword: '',
        }}
        validateOnBlur
        onSubmit={(values: SignUpTypes, { setSubmitting }) => {
          handleSubmitChange(values, setSubmitting);
        }}
        validationSchema={validationSignUp}
      >
        {({ handleSubmit, values, errors, handleChange, isSubmitting }) => {
          return (
            <form onSubmit={handleSubmit}>
              <Grid px="25%" container justifyContent="center" gap="20px">
                <TextField
                  value={values.email}
                  onChange={handleChange}
                  name="email"
                  label="email"
                  error={!!errors.name}
                  helperText={errors.email}
                  fullWidth
                />
                <TextField
                  value={values.name}
                  onChange={handleChange}
                  name="name"
                  label="name"
                  error={!!errors.name}
                  helperText={errors.name}
                  fullWidth
                />
                <PasswordField
                  label="password"
                  name="password"
                  value={values.password}
                  error={errors.password}
                  handleChange={handleChange}
                />

                <PasswordField
                  label="repeat password"
                  name="repeatPassword"
                  value={values.repeatPassword}
                  handleChange={handleChange}
                  error={errors.repeatPassword}
                />
                <Button
                  variant="contained"
                  disabled={isSubmitting}
                  type="submit"
                  color="primary"
                  fullWidth
                >
                  Register
                </Button>
              </Grid>
            </form>
          );
        }}
      </Formik>
    </>
  );
};

export default SignUpForm;
